<template>
        <div class="px-2">
            <div>
                <input type="text" class="form-control" v-model="zone.name" v-on:input="changeName()" autofocus>
            </div>
            <div class="my-2">
                {{$t('enable_following_tracker')}}<br>
                <div v-if="devices_ids">
                     <multiselect
                            v-model="zone.devices"
                            :options="[-1, ...devices_ids]"
                            :multiple="true"
                            :close-on-select="false"
                            :clear-on-select="false"
                            :hide-selected="true"
                            :preserve-search="true"
                            :select-label="$t('select')"
                            :selected-label="$t('selected')"
                            :deselect-label="$t('deselect_label')"
                            :placeholder="$t('select_device_alert')"
                            :custom-label="device_label"
                            @select="deviceSelect">
                    </multiselect>
                </div>
            </div>
            <div class="form-group row" v-if="!zone.id">
                <label for="selectplace"
                       class="col-sm-4 col-form-label text-right">{{$t('center_zone_alert_place')}}
                </label>
                <div class="col-sm-8">
                    <select class="form-control selec_place" v-model="place" v-on:change="selectPlace(place)">
                        <option :value="zone.lat+','+zone.lng">{{$t('set_up_the_alert')}}
                        </option>
                        <option v-for="place in places" :key="place.id" :value="place.lat +','+place.lng">
                            {{ place.name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="my-2">
                {{$t('adress')}}
                <input class="form-control" type="text" :id="zone.id" ref="zone_address" v-model="address" />
                <span class="text-muted">{{$t('drag_position')}}</span>
            </div>
          <div class="d-flex align-items-center justify-content-center mt-3">
            <span class="mr-2">{{$t('circleZone')}}</span>
            <div class="custom-control custom-switch">
              <input
                  type="checkbox"
                  class="custom-control-input"
                  :id="'customSwitch_' + zone.id"
                  v-model="isPolygon"
                  @change="handleCheckboxChange"
              />
              <label class="custom-control-label" :for="'customSwitch_' + zone.id"></label>
            </div>
            <span class="mr-2">{{$t('polygonZone')}}</span>
          </div>
            <div class="my-2" v-if="!zone.polygon">
                {{$t('radius')}} (m) <input class="form-control" type='number'
                                            v-model="zone.radius" @change="updateRadius" />
                <input id="radius-slider" name="radius"
                       type="range" min="100" max="60000" step="20" v-model="zone.radius" @change="updateRadius">
            </div>
            <div class="my-2">
                {{$t('when')}}
                <div class="btn-group">
                    <input id="entering" class="mx-2" type="radio" v-model="zone.mode" value="zonein">
                    <label for="entering">{{$t('entering')}}</label>
                    <input id="leaving" class="mx-2" type="radio" v-model="zone.mode" value="zoneout">
                    <label for="leaving">{{$t('leaving')}}</label>
                    <input id="both" class="mx-2" type="radio" v-model="zone.mode" value="zoneinout">
                    <label for="both">{{$t('both')}}</label>
                </div>
            </div>
            <div class="my-2">
                <label for="email_notification">{{$t('send_email')}}</label>
                <input id="email_notification" type="checkbox" class="mt-2" v-model="zone.email_notification">
            </div>
            <div class="my-2">
                {{$t('following_contact')}}<br>
                <div v-if="contacts_ids">
                    <multiselect
                            v-model="zone.contacts"
                            :options="contacts_ids"
                            :multiple="true"
                            :close-on-select="false"
                            :clear-on-select="false"
                            :hide-selected="true"
                            :preserve-search="true"
                            :placeholder="$t('select_contact_alert')"
                            :select-label="$t('select')"
                            :selected-label="$t('selected')"
                            :deselect-label="$t('deselect_label')"
                            :custom-label="contact_label"
                    >
                    </multiselect>
                    <div class="form-inline" >
                        <input class="form-control-sm col-5" :placeholder="$t('enter_name')" v-model="new_contact.name">
                        <input class="form-control-sm col-5" :placeholder="$t('enter_email')" v-model="new_contact.email">
                        <button class="btn btn-sm btn-primary btn-wrap-text col-2" v-bind:class="{'active': (new_contact.email.length>4) }" v-on:click="add_contact()">
                        <span data-feather="plus-circle"></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>



import Multiselect from 'vue-multiselect'
import {HTTP} from "../http-constants"
import {rectangle_from_position} from "@/gmaps"

export default {
    name:'zone-edit',
    components: {
        Multiselect
    },
    props: ['places', "contacts", "devices", "zoneid"],
    data: function () {
        return {
          zone: {contacts: [], devices: [], name:"-"},
          contacts_ids: [],
          devices_ids: [],
          new_contact: {'email': '', 'name': ''},
          address: "",
          place: "",
          autocomplete: null,
          isPolygon: undefined,
        }
    },
    computed:{
    },
  watch: {

  },
    delimiters: ['${', '}'],
    methods: {
      handleCheckboxChange(event) {
        console.log("check box change:", this.zone);

        if (this.isPolygon) {
          console.log("Creating polygon", this.zone);
          this.zone.polygon = rectangle_from_position({lat: this.zone.lat, lng: this.zone.lng}, 300);
        } else {
          this.zone.polygon = null;
        }
        this.$parent.$emit('zone_changed', this.zone);

      },
      'changeName': function () {
            console.log("change name", this.zone);
            this.$parent.$emit('zone_rename', this.zone);
        },
        'contact_label': function (option) {
            var contacts = this.contacts.filter(a => a.id == option);
            if (contacts.length) {
                var contact = contacts[0];
                if (contact.name) {
                    return contact.name;
                }
                return contact.email;
            }
            return `${option}`
        },
      device_label(option) {
        if (option < 0) {
          return app.$t('select_all');
        }
        const devices = this.devices.filter(a => a.id === option);
        if (devices.length) {
          return devices[0].name;
        }
        return `${option}`
      },
      deviceSelect(option) {
        if (option === -1) {
          this.zone.devices = this.devices_ids;
        } else {
          this.zone.devices.push(option);
        }
      },
        'setZone': function (zone) {
            console.log("set zone", zone);
            if (zone.contacts == null) {
                zone.contacts = [];
            }
            if (zone.devices == null) {
                zone.devices = [];
            }

            this.isPolygon= !!zone.polygon;
            this.zone = zone;

            console.log("zone now", this.zone);
            this.resolve_address();

        },
        'setPosition': function (position) {
            this.zone.lat = position.lat();
            this.zone.lng = position.lng();
            self.resolve_address(position);
        },
        'resolve_address': function() {
            var _zone = this.zone;
            var point = new google.maps.LatLng(_zone.lat, _zone.lng);
            var geocoder = new google.maps.Geocoder();
            var self = this;
            console.log("resolve_address");
            geocoder.geocode({'location': point}, function (results, status) {

                if (status === 'OK') {
                    console.log("resolved address", results);

                    if (results[0]) {
                        self.address = results[0].formatted_address;
                    } else {
                        window.alert('No results found');
                    }
                    self.initAutoComplete();
                } else {
                    window.alert('Geocoder failed due to: ' + status);
                }
            });
        },
        'add_contact': function () {
            var self = this;
            HTTP.post('/alertcontacts/', this.new_contact)
                .then(function (re) {
                    var contact = re.data;
                    self.contacts.push(contact);
                    self.contacts_ids.push(contact.id);
                    self.zone.contacts.push(contact.id);
                    self.new_contact.name = '';
                    self.new_contact.email = '';
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        'moveZone': function(position)
        {
            this.zone.lat = position.lat();
            this.zone.lng = position.lng();

            this.$parent.$emit('zone_move', this.zone)
        },

        'selectPlace': function(elem) {
            var latlngStr = elem.split(",", 2);
            var lat = parseFloat(latlngStr[0]);
            var lng = parseFloat(latlngStr[1]);

            var position = new google.maps.LatLng(lat, lng);
            this.moveZone(position);

            this.resolve_address();
        },
        'updateRadius': function (sliderValue) {
            let radius = this.zone.radius;
            if (radius < 100){
                this.zone.radius=100;
            }
            if (radius > 60000) {
                this.zone.radius = 60000;
            }
            this.$parent.$emit('zone_resize', this.zone)
        },
        initAutoComplete(){
          const input = this.$refs.zone_address;

          this.autocomplete = new google.maps.places.Autocomplete(input, {
            region: 'EU',
          });

          this.autocomplete.setFields(['geometry', 'icon', 'name', 'formatted_address']);
          console.log("setup autocomplete", this.autocomplete);
          const self = this;

          this.autocomplete.addListener('place_changed', function () {
            console.log("place changed");
            const place = self.autocomplete.getPlace();
            if (!place.geometry) {
              console.log("No details available for input: '" + place.name + "'");
              const geocoder = new google.maps.Geocoder();
              geocoder.geocode({'address': place.name, region: 'EU'}, function (results, status) {
                if (status === 'OK') {
                  //console.log("results", results);
                  self.moveZone(results[0].geometry.location);
                  self.address = results[0].formatted_address;
                }
              });
              return
            }
            //console.log("Place is known ", place);
            self.address = place.formatted_address;
            self.moveZone( place.geometry.location);

          });
      }

    },
  mounted() {
   // this.initAutoComplete();
  },
  created: function () {
        this.$parent.$on('zone_edit', zone => {
          if (this.zone && zone.id !== this.zoneid) {
            return;
          }
          console.log("zone edit for  zoneid " + this.zoneid);
          this.devices_ids = this.devices.map(a => a.id);
          this.contacts_ids = this.contacts.map(a => a.id);

          this.setZone(zone);
          if (this.zone) {
            this.place = '' + zone.lat + ',' + zone.lng;
          }
         // this.initAutoComplete();
        });
    }
}

</script>
